var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.33,
    height: 19.982,
    viewBox: "0 0 18.33 19.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toggle-menu-v",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M3.511,1.652H20.126a.8.8,0,0,0,.842-.842A.753.753,0,0,0,20.157,0H3.511A.778.778,0,0,0,2.7.842.753.753,0,0,0,3.511,1.652Z",
    transform: "translate(-2.669 0)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M20.088,58.7H3.442a.842.842,0,0,0,0,1.683H20.057a.8.8,0,0,0,.842-.842A.762.762,0,0,0,20.088,58.7Z",
    transform: "translate(-2.6 -40.401)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M9.359,18.938,5.805,21.931a1.339,1.339,0,0,0-.405.9,1.1,1.1,0,0,0,.405.842L9.39,26.762h0a.947.947,0,0,0,.655.249c.156,0,.343,0,.405-.094a.964.964,0,0,0,.655-.9V19.78a1.087,1.087,0,0,0-.655-1A1.036,1.036,0,0,0,9.359,18.938Zm.187,5.736L7.3,22.835,9.546,21Z",
    transform: "translate(-4.527 -12.859)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M38.465,16H30.142a.842.842,0,1,0,0,1.683h8.323a.8.8,0,0,0,.842-.842A.819.819,0,0,0,38.465,16Z",
    transform: "translate(-20.977 -11.012)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M38.465,29.3H30.142a.842.842,0,1,0,0,1.683h8.323a.8.8,0,0,0,.842-.842A.819.819,0,0,0,38.465,29.3Z",
    transform: "translate(-20.977 -20.166)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M38.465,42.7H30.142a.842.842,0,1,0,0,1.683h8.323a.842.842,0,0,0,0-1.683Z",
    transform: "translate(-20.977 -29.389)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.bbb2f5d757254b3552919f0e407c9c27.svg";
export { ForwardRef as ReactComponent };